module.exports = {"411326001":"龙城街道","411326002":"商圣街道","411326101":"荆紫关镇","411326102":"老城镇","411326103":"香花镇","411326104":"厚坡镇","411326105":"丹阳镇","411326106":"盛湾镇","411326107":"金河镇","411326108":"寺湾镇","411326109":"仓房镇","411326110":"上集镇","411326111":"马蹬镇","411326301":"西簧乡","411326302":"毛堂乡","411326303":"大石桥乡","411326304":"滔河乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411326.json
// module id = 1645
// module chunks = 0